<template>
  <div>
    <el-dialog
      :title="dataForm.id ? 'Edit Billing Exchange Rate' : 'Add Billing Exchange Rate'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form :model="dataForm" :rules="dataRule" ref="formRef" label-position="right" label-width="150px">
        <el-form-item label="From Currency" prop="fromCurrency">
          <el-select v-model="dataForm.fromCurrency" filterable clearable placeholder="Select Currency" class="wdb100">
            <el-option v-for="item in currencyList" :key="`modal-from-${item.currency}`" :label="item.currency" :value="item.currency"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="To Currency" prop="toCurrency">
          <el-select v-model="dataForm.toCurrency" filterable clearable placeholder="Select Currency" class="wdb100">
            <el-option v-for="item in currencyList" :key="`modal-to-${item.currency}`" :label="item.currency" :value="item.currency"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Exchange Rate" prop="exchangeRate">
          <el-input-number
            v-model="dataForm.exchangeRate"
            :precision="4"
            :min="0"
            :step="0.0001"
            controls-position="right"
            class="tal wdb100"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      dataForm: {
        id: "",
        fromCurrency: "",
        toCurrency: "",
        exchangeRate: undefined,
      },
      dataRule: {
        fromCurrency: [{ required: true, message: "Please enter", trigger: "submit" }],
        toCurrency: [{ required: true, message: "Please enter", trigger: "submit" }],
        exchangeRate: [{ required: true, message: "Please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("currency", ["currencyList"]),
  },
  methods: {
    // 初始化
    async init(data) {
      this.submitLoading = false;
      this.dialogVisible = true;
      await this.$nextTick();
      this.$refs.formRef.resetFields();
      if (data) {
        this.dataForm = {
          id: data.id,
          fromCurrency: data.fromCurrency,
          toCurrency: data.toCurrency,
          exchangeRate: data.exchangeRate || undefined,
        };
      } else {
        this.$set(this.dataForm, "id", null);
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return this.$http.post(`/admin/billingExchangeRate/update/${params.id}`, params);
      } else {
        return this.$http.post("/admin/billingExchangeRate/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.dialogVisible = false;
                  this.$emit("update");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
